import { render, staticRenderFns } from "./CustomerDocumentAnalysisInvoiceVsPaymentComparisonBarChart.vue?vue&type=template&id=532417f3"
import script from "./CustomerDocumentAnalysisInvoiceVsPaymentComparisonBarChart.vue?vue&type=script&lang=ts"
export * from "./CustomerDocumentAnalysisInvoiceVsPaymentComparisonBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports